<span [hidden]="!toolTipText" class="text-link-tooltip" [placement]="position" [ngbPopover]="popContent" container="body"
  triggers="mouseenter:mouseleave"> {{ text }}
  <img [src]="ICONS.INFO" alt="info"/>
</span>

<span [hidden]="toolTipText" class="cursor-pointer">
  {{ text }}
</span>

<ng-template #popContent>
  <div [innerHTML]="sanitizerHtml(toolTipText)"></div>
</ng-template>